import { REQUEST_HELPLY_COPILOT_DRAFT } from 'constants/action_types'

// Opens the Helply copilot drawer and asks it to draft a reply (see the
// reducer + HelplyCopilotPanel). Dispatched from the AI Draft button / `d`
// hotkey when the account has the copilot addon.
export function doRequestHelplyCopilotDraft() {
  return {
    type: REQUEST_HELPLY_COPILOT_DRAFT,
  }
}
